<div class="container-main">
  <div class="container">
    <div class="row"> 
      <div class="col-12 form-group">
        <span class="title-home">Cursos Android ANT</span>
      </div>
      <div class="col-12 form-group">
        <img class="image-course" [src]="main.photoUrl">
      </div>
      <div class="col-12 col-sm-6 form-group">
        <a class="link-main" (click)="goToPage(main)">Más Información...</a>
      </div>
      <div class="col-12 col-sm-6 form-group">
        <button class="button-main" (click)="goToCourse(main)">Obtener curso</button>
      </div>
      <div class="col-12 form-group">
        <p class="subtitle-home">{{ main.title }}</p>
      </div>
      <div class="col-12 col-sm-6 col-md-3 form-group" *ngFor="let course of courses">
        <div class="card" style="width: 100%;">
          <img class="card-img-top" [src]="course.photoUrl">
          <div class="card-body">
            <h5 class="card-title">{{ course.title }}</h5>
            <p class="card-text">{{ course.subtitle }}</p>
            <a class="link-card" (click)="goToPage(course)">Más Información...</a>
          </div>
          <div class="card-footer">
            <button class="button-card" (click)="goToCourse(course)">Obtener curso</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>